export default "__VITE_ASSET__DUlGLf9i__"